import React from 'react'
import "./../styles/article.css";

const Hearts = () => {
    return (
        <div className="card">
            <div className="Home__container">
                <div className="article-border">
                    <div className="article-container">
                        <h1 className='article-mainheading'>Harmonizing Hearts: The Inspiring Role of the Audience
                            in a Show Choir Contest</h1>

                        <div className='paragraphwimage'>
                            <img src='images/article7/1.jpg' />
                            <p> One of the most exhilarating aspects of a show
                                choir contest lies in the boundless energy of
                                the audience. This diverse gathering of
                                spectators brings with them a myriad of
                                motivations, yet they share two profound
                                commonalities: an unwavering desire to savor
                                the complete experience and a heartfelt
                                commitment to uplift the performers.</p>
                        </div>



                        <div id='art7-s2' className='mb-20'>
                            <div className='smaller-article-border'>
                                <div className='smaller-border-content'>
                                    <h2 className='mb-10 mt-20 sub-head' style={{ textAlign: 'center' }}>You Should . . . </h2>

                                    <li className='art-7li'>Support all show choirs by
                                        applauding/cheering at high
                                        performance points and at their show
                                        finale.</li>

                                    <h2 className='sub-head mb-10'>Be respectful of all other spectators by:</h2>

                                    <ul className='hearts-list'>
                                        <li>Not talking during performance </li>
                                        <li>Not talking on cell phones or texting. Best
                                            to turn off cell phones </li>
                                        <li>Not allow children to play in the stands</li>
                                        <li>Not obstructing the view of others.
                                            (Especially if you have flags, signs,
                                            banners)</li>
                                        <li>Not go to the bathroom or snack bar
                                            during a performance </li>
                                        <li>Never make negative comments about
                                            other show choirs </li>
                                        <li>Never boo</li>
                                        <li>Never approach judges with questions
                                            or concerns </li>
                                        <li>Never play games or read
                                            BetweenChoirs.com while a show choir is
                                            performing</li>
                                        <li>Thank event sponsors and volunteers</li>
                                    </ul>



                                </div>

                            </div>


                            <p className='mb-20'>In this vibrant tapestry of
                                enthusiasts, you are called
                                upon to be the true
                                conductor of unity and
                                support. Your role is to
                                champion all the show
                                choirs, to ignite applause
                                that reverberates through
                                the very soul of the
                                competition, and to join in a
                                resounding cheer as the
                                grand finale crescendos.</p>

                            <p> Amidst this harmonious
                                symphony of camaraderie,
                                let your conduct be a
                                reflection of respect for your
                                fellow spectators. Honor the
                                sacred silence during
                                performances, let your cell
                                phones rest in hushed
                                reverence, and allow the
                                uninterrupted flow of artistic
                                expression to captivate
                                your senses. Shield the view
                                of others from obstructions,
                                mindful that the vibrancy of
                                your flags, signs, or banners does not eclipse the brilliance on the stage.
                                Refrain from deserting your seat for bathroom breaks or snacks during a
                                performance, for these moments are fleeting, and every note is a
                                treasure.</p>


                        </div>


                        <p className='mb-20'>And when questions or concerns arise, remember that the judges are the
                            impartial arbiters of this musical odyssey. Resist the temptation to
                            approach them, for the beauty of their judgment lies in its detachment.
                            In this orchestra of collective support, negativity and discord find no
                            place. Let your words be a soothing melody of encouragement, and
                            banish any thought of booing to the furthest reaches of your heart.
                            Instead, let your applause and cheers be the ovation that echoes across
                            the ages.</p>


                        <div className='paragraphwimage-large'>
                            <img src='images/article7/2.jpg' />

                            <p> Lastly, let your gratitude resound like a
                                triumphant crescendo. Offer thanks to
                                the tireless event sponsors and the
                                dedicated volunteers who make this
                                spectacle possible. They are the unsung
                                heroes behind the scenes, ensuring that
                                the music of unity and harmony fills the
                                air.</p>
                        </div>


                        <p> In the grand overture of a show choir contest, you, the audience, hold the
                            power to elevate the experience into an unforgettable symphony of
                            support and togetherness. Embrace this role with unwavering dedication,
                            and let your presence be a testament to the enduring spirit of musical
                            camaraderie.</p>



                    </div>

                    <div className='article-ad'>
                        <a href='https://www.mymusicfuture.com/' target='_blank'>
                            <img src='images/mmf-1.jpg' />
                        </a>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Hearts